import { Turnstile } from "@marsidev/react-turnstile";

interface AuthTurnstileProps {
  onSuccess: (token: string) => void;
}

export default function AuthTurnstile({ onSuccess }: AuthTurnstileProps) {
  return (
    <Turnstile
      siteKey={process.env.TURNSTILE_SITE_KEY || ""}
      className="mx-auto"
      onSuccess={onSuccess}
      options={{
        theme: "auto",
        language: "auto",
        appearance: "always",
        size: "flexible",
        feedbackEnabled: false,
        responseField: false,
      }}
    />
  );
}
